import React from 'react';
/**
 * Custom React hook to initialize a chip label callback once on first render.
 *
 * Useful when you want to pass the initial chip label tied to a field during setup.
 *
 * @param {object} props - The hook parameters.
 * @param {(field: string, chipLabel: string) => void} props.onInitialChipLabel - Callback invoked with field and label on initial render.
 * @param {string} props.field - The field identifier for the chip.
 * @param {string} props.chipLabel - The label value for the chip.
 */
export function useChip({ onInitialChipLabel, field, chipLabel }) {
    const [initialRender, setInitialRender] = React.useState(true);
    React.useEffect(() => {
        if (initialRender) {
            if (field && chipLabel && onInitialChipLabel) {
                onInitialChipLabel(field, chipLabel);
            }
            setInitialRender(false);
        }
    }, []);
}
